"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _cmsDesignComponent = require("@tencent/cms-design-component");
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const formatFreeWithCreditIteration = (properties, options = {}) => {
  const modTitle = properties.modTitle,
    color = properties.color,
    description = properties.description,
    _properties$list = properties.list,
    list = _properties$list === void 0 ? [] : _properties$list,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura;
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  // 处理头部配置
  const resultHeadList = list.map(headItem => {
    const _headItem$txt = headItem.txt,
      txt = _headItem$txt === void 0 ? '' : _headItem$txt,
      _headItem$href = headItem.href,
      href = _headItem$href === void 0 ? '' : _headItem$href,
      _headItem$type = headItem.type,
      type = _headItem$type === void 0 ? 'a' : _headItem$type,
      _headItem$modalTitle = headItem.modalTitle,
      modalTitle = _headItem$modalTitle === void 0 ? '' : _headItem$modalTitle,
      _headItem$richTextCon = headItem.richTextContent,
      richTextContent = _headItem$richTextCon === void 0 ? '' : _headItem$richTextCon,
      _headItem$richBtnTxt = headItem.richBtnTxt,
      richBtnTxt = _headItem$richBtnTxt === void 0 ? [] : _headItem$richBtnTxt;
    return {
      txt,
      href: formatUrlString(href),
      type,
      modalTitle,
      richTextContent: formatUrlInText(richTextContent),
      richBtnTxt
    };
  });
  const resultHeadConfig = {
    description,
    list: resultHeadList
  };
  const resultConfiguration = [];
  for (let i = 0; i < configuration.length; i++) {
    const item = configuration[i];
    const _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$agreement = item.agreement,
      agreement = _item$agreement === void 0 ? [] : _item$agreement,
      _item$price = item.price,
      price = _item$price === void 0 ? '0' : _item$price,
      _item$symbol = item.symbol,
      symbol = _item$symbol === void 0 ? '$' : _item$symbol,
      _item$prompt = item.prompt,
      prompt = _item$prompt === void 0 ? '' : _item$prompt,
      _item$txt = item.txt,
      txt = _item$txt === void 0 ? '' : _item$txt,
      _item$href = item.href,
      hrefBase = _item$href === void 0 ? '' : _item$href,
      _item$type = item.type,
      type = _item$type === void 0 ? '1' : _item$type,
      _item$commodityObject = item.commodityObject,
      commodityObject = _item$commodityObject === void 0 ? '{}' : _item$commodityObject,
      isLink = item.isLink;
    const href = formatUrlString(hrefBase);
    const buttonConfig = {
      txt: txt || '',
      colType: 'blue',
      text: '文字',
      'text-icon': '文字+图标',
      sizeType: 'middle',
      alignType: 'center',
      onCallback: null,
      extendProps: {
        'report-event-goal': 'click_free_with_credit_lteration',
        'report-event': type === '1' ? 'click_free_with_credit_lteration_business_button' : 'click_free_with_credit_lteration_person_button',
        'report-ext1': txt,
        'report-ext2': href
      }
    };
    const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
    const itemData = _objectSpread(_objectSpread({
      type: type || '1',
      title: title || '',
      agreement,
      price,
      prompt,
      symbol,
      isLink
    }, resultCommodityObject), {}, {
      buttonConfig,
      href
    });
    buttonConfig.onCallback = function () {
      window.asyncReceiveCommodity(itemData);
    };
    resultConfiguration.push(itemData);
  }
  return {
    modTitle,
    headConfig: resultHeadConfig,
    configuration: resultConfiguration,
    bgColor: color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatFreeWithCredit = formatFreeWithCreditIteration(data, {
        domains
      }),
      modTitle = _formatFreeWithCredit.modTitle,
      headConfig = _formatFreeWithCredit.headConfig,
      configuration = _formatFreeWithCredit.configuration,
      bgColor = _formatFreeWithCredit.bgColor;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_freeWithCreditIteration', componentKey, modTitle])), /*#__PURE__*/React.createElement(_cmsDesignComponent.FreeWithCreditIteration, {
      flexTitle: modTitle,
      configuration: configuration,
      headConfig: headConfig,
      style: bgStyle
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}